define(['angular'], function(angular) {


    /**
     * @class ScenarioTypeService
     */
    function ScenarioTypeService(orderFormService) {
        var self = this;
        var scenarioTypes = [];

        self.initScenarioTypes = function _initScenarioTypes(orderForm) {
            scenarioTypes = orderForm.scenarioTypes;
        };

        self.getScenarioTypes = function getScenarioTypes() {
            return scenarioTypes;
        };

        self.getScenarioTypeByCode = function getScenarioTypeByCode(scenarioTypeCode) {
            return scenarioTypes.find(function(scenarioType) {
                return scenarioType.code === scenarioTypeCode;
            });
        };

        /**
         * Get a array of the codes of all the scenarioTypes
         * @return promise
         */
        self.getScenarioTypesCodes = function getScenarioTypesCodes() {
            var codes = [];

            var p = new Promise(function(resolve, reject) {
                if (scenarioTypes) {
                    codes = scenarioTypes.map(function(scenarioType) {
                        return scenarioType.code;
                    });
                    resolve(codes);
                }
            });

            return p;
        };

        return self;
    }

    ScenarioTypeService.$inject = ['orderFormService'];

    angular.module('app.bdc.common.scenarioTypeService', []).factory('scenarioTypeService', ScenarioTypeService);
});
